var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-page",
    {
      attrs: {
        "show-grid": _vm.showGrid,
        "grid-settings": _vm.layout.EditorSettings.GridSettings,
        "zoom-level": _vm.zoomLevel,
        "page-settings": _vm.layout.PageSettings,
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "header",
          style: { height: _vm.layout.PageSettings.HeadingHeight + "mm" },
        },
        [
          _vm._l(_vm.headerLogos, function (logo, i) {
            return _c("app-logo", { key: `logo-${i}`, attrs: { logo: logo } })
          }),
          _vm._l(_vm.headerFreeBlocks, function (block, i) {
            return _c("app-free-block", {
              key: `free-block-${i}`,
              attrs: { "free-block": block, lang: _vm.lang },
            })
          }),
          _c("app-heading", {
            attrs: {
              heading: _vm.layout.Heading,
              "page-settings": _vm.layout.PageSettings,
              "heading-height": _vm.layout.PageSettings.HeadingHeight,
              lang: _vm.lang,
            },
          }),
          _c("app-client-heading", {
            attrs: {
              heading: _vm.layout.ClientHeading,
              "page-settings": _vm.layout.PageSettings,
              lang: _vm.lang,
              "heading-height": _vm.layout.PageSettings.HeadingHeight,
              "contact-group-id": _vm.contactGroupId,
            },
          }),
          _c("app-client-heading", {
            attrs: {
              heading: _vm.layout.DeliveryAddressHeading,
              lang: _vm.lang,
              "page-settings": _vm.layout.PageSettings,
              "heading-height": _vm.layout.PageSettings.HeadingHeight,
              "contact-group-id": _vm.contactGroupId,
            },
          }),
          _c("app-section-splitter", {
            model: {
              value: _vm.layout.PageSettings.HeadingHeight,
              callback: function ($$v) {
                _vm.$set(_vm.layout.PageSettings, "HeadingHeight", $$v)
              },
              expression: "layout.PageSettings.HeadingHeight",
            },
          }),
        ],
        2
      ),
      _c(
        "div",
        { staticClass: "body" },
        [
          _vm._l(_vm.bodyLogos, function (logo, i) {
            return _c("app-logo", { key: `logo-${i}`, attrs: { logo: logo } })
          }),
          _vm._l(_vm.bodyFreeBlocks, function (block, i) {
            return _c("app-free-block", {
              key: `free-block-${i}`,
              attrs: { "free-block": block, lang: _vm.lang },
            })
          }),
          _vm._l(_vm.aboveTableFreeLines, function (line, i) {
            return _c("app-free-line", {
              key: `free-line-${i}`,
              attrs: { line: line, lang: _vm.lang, layout: _vm.layout },
            })
          }),
          _c(
            "div",
            { staticClass: "inner-body" },
            [
              _c("app-sale-table", {
                attrs: {
                  cols: _vm.layout.Cols,
                  "title-line": _vm.layout.TitleLine,
                  "date-line": _vm.layout.DateLine,
                  "before-image": _vm.layout.DetailBeforeImage,
                  "after-image": _vm.layout.DetailAfterImage,
                  lang: _vm.lang,
                  "page-settings": _vm.layout.PageSettings,
                },
              }),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "div",
        {
          staticClass: "footer",
          style: _vm.layout.FootMargin.getPaddingStyle(),
        },
        [
          _vm._l(_vm.footerLogos, function (logo, i) {
            return _c("app-logo", { key: `logo-${i}`, attrs: { logo: logo } })
          }),
          _vm._l(_vm.footerFreeBlocks, function (block, i) {
            return _c("app-free-block", {
              key: `free-block-${i}`,
              attrs: { "free-block": block, lang: _vm.lang },
            })
          }),
          _c(
            "div",
            { staticClass: "inner-footer" },
            [
              _c("app-totals", {
                attrs: { layout: _vm.layout, lang: _vm.lang },
              }),
              _vm.showRequirements
                ? _c("app-requirements", {
                    attrs: {
                      "example-document": _vm.exampleDocument,
                      lang: _vm.lang,
                      layout: _vm.layout,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }